// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-Ki9","colBig":"styles_colBig__3ZNVC","colSmall":"styles_colSmall__2xO2L","shopifyNameWrapper":"styles_shopifyNameWrapper__2-FUV"};